import { ChangeEvent, FC, memo, useCallback } from "react";
import { FormControlLabel, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { SpeedScreenFormLayout, useSettings } from "@framework/provider-settings";

import { StyledRadio, StyledRadioGroup } from "../styled";

const SCREEN_FORM_LAYOUT_OPTIONS: { value: SpeedScreenFormLayout; labelId: string }[] = [
  { value: "1", labelId: "pages.profile.speedScreenFormOne" },
  { value: "2V", labelId: "pages.profile.speedScreenFormTwoVertical" },
  { value: "2H", labelId: "pages.profile.speedScreenFormTwoHorizontal" },
  { value: "4", labelId: "pages.profile.speedScreenFormFour" },
];

export const SpeedScreenFormLayoutSelector: FC = memo(() => {
  const { getSpeedScreenFormLayout, setSpeedScreenFormLayout } = useSettings();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const selectedLayout = SCREEN_FORM_LAYOUT_OPTIONS.find(({ value }) => value === event.target.value);
      if (selectedLayout) {
        setSpeedScreenFormLayout(selectedLayout.value);
      }
    },
    [setSpeedScreenFormLayout],
  );

  return (
    <>
      <Typography id="speed-screen-form-layout-label" variant="h6" gutterBottom>
        <FormattedMessage id="pages.profile.titleSpeedScreenFormLayout" />
      </Typography>
      <StyledRadioGroup
        row
        name="speedScreenFormLayout"
        aria-labelledby="speed-screen-form-layout-label"
        value={getSpeedScreenFormLayout()}
        onChange={handleChange}
      >
        {SCREEN_FORM_LAYOUT_OPTIONS.map(({ value, labelId }) => (
          <FormControlLabel
            key={value}
            value={value}
            control={<StyledRadio name="speedScreenFormLayout" />}
            label={<FormattedMessage id={labelId} />}
          />
        ))}
      </StyledRadioGroup>
      <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
        <FormattedMessage id="pages.profile.autoApplyHint" />
      </Typography>
    </>
  );
});
